<template>
  <li class="smart-link-item">
    <el-input
      v-model.trim="keywords"
      :disabled="disabled"
      placeholder="Keywords"
      class="keywords-input"
      clearable
    />
    <el-input
      v-model.trim="link"
      :disabled="disabled"
      placeholder="Link"
      class="link-input"
      clearable
    />
    <el-button
      :disabled="disabled"
      type="danger"
      icon="el-icon-delete"
      circle
      @click="handleRemoveItem"
    />
  </li>
</template>

<script>
export default {
  name: 'EditorialSmartLinkItem',
  props: {
    smartLink: {
      type: Object,
      required: true,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    keywords: {
      get() {
        return this.smartLink.text
      },
      set(newValue) {
        const updatedSmartLink = { ...this.smartLink }
        updatedSmartLink.text = newValue
        this.$emit('update', updatedSmartLink)
      },
    },
    link: {
      get() {
        return this.smartLink.url
      },
      set(newValue) {
        const updatedSmartLink = { ...this.smartLink }
        updatedSmartLink.url = newValue
        this.$emit('update', updatedSmartLink)
      },
    },
  },
  methods: {
    handleRemoveItem() {
      this.$emit('remove', this.smartLink)
    },
  },
}
</script>

<style lang="scss" scoped>
.smart-link-item {
  display: flex;
  flex-flow: row;
  padding-bottom: 5px;
  .keywords-input {
    max-width: 200px;
  }
  .link-input {
    margin: 0 8px;
  }
}
</style>
